<template>
  <section class="qilin-progress">
    <div class="qilin-progress__head">
      <div>
        <small>{{ pet.isMaxLevel ? 'สายสัมพันธ์' : 'การเติบโต' }}</small>
        <strong>{{ pet.isMaxLevel ? `${pet.bondStars} ดาวผูกพัน` : `เลเวล ${pet.level} / ${pet.maxLevel}` }}</strong>
      </div>
      <span>{{ current }} / {{ target }} XP</span>
    </div>
    <div
      class="qilin-progress__track"
      role="progressbar"
      :aria-valuenow="current"
      :aria-valuemin="0"
      :aria-valuemax="target"
    >
      <div class="qilin-progress__fill" :style="{ width: `${percent}%` }"></div>
    </div>
    <p>{{ helper }}</p>
  </section>
</template>

<script>
export default {
  name: 'QilinProgress',
  props: { pet: { type: Object, required: true } },
  computed: {
    current () { return this.pet.isMaxLevel ? this.pet.bondIntoStar : this.pet.xpIntoLevel },
    target () { return this.pet.isMaxLevel ? this.pet.bondStepXp : this.pet.xpToNext },
    percent () { return this.target ? Math.min(100, Math.round(this.current / this.target * 100)) : 100 },
    helper () {
      if (this.pet.isMaxLevel) return `อีก ${this.target - this.current} XP รับดาวผูกพันดวงถัดไป`
      const nextStage = [5, 10, 15, 20, 25, 30].includes(this.pet.level)
      return nextStage
        ? `อีก ${this.target - this.current} XP วิวัฒนาการเป็นร่างถัดไป`
        : `อีก ${this.target - this.current} XP ถึงเลเวล ${this.pet.level + 1}`
    }
  }
}
</script>

<style scoped>
.qilin-progress { padding: 17px; border: 1px solid rgba(255, 255, 255, .09); border-radius: 18px; background: rgba(255, 255, 255, .055); }
.qilin-progress__head { display: flex; align-items: flex-end; justify-content: space-between; color: #fff; }
.qilin-progress small, .qilin-progress strong { display: block; }
.qilin-progress small { color: #73d9bd; font-size: 11px; font-weight: 800; letter-spacing: .05em; }
.qilin-progress strong { margin-top: 2px; font-size: 18px; }
.qilin-progress__head > span { color: rgba(255, 255, 255, .62); font-size: 12px; }
.qilin-progress__track { height: 11px; overflow: hidden; margin-top: 13px; border-radius: 99px; background: rgba(0, 0, 0, .34); }
.qilin-progress__fill { height: 100%; border-radius: inherit; background: linear-gradient(90deg, #3bd5ad, #fbc844); box-shadow: 0 0 16px rgba(59, 213, 173, .35); transition: width .45s ease; }
p { margin: 9px 0 0; color: rgba(255, 255, 255, .58); font-size: 12px; }
</style>
